/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPhone} from '@fortawesome/pro-duotone-svg-icons';

const SecurityIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faPhone} {...props} />
);

export default SecurityIcon;
